import React, { useEffect, useState } from 'react';
import OrganizationIcon from '../../Assets/General/SettingPageIcon';
import { OrganizationForm } from '../../Components/Form';
import { FormLayout } from '../../Components';
import useToggleClick from '../../Hooks';
import { Prompt } from 'react-router-dom';
import './AddOrganization.css';
import { useTranslation } from 'react-i18next';

const AddOrganization = ({ handleToast }) => {
  const { t } = useTranslation();
  const [, handleCrossAlert] = useToggleClick();
  const [showPrompt, setPrompt] = useState(false);

  useEffect(() => {
    document.title = t('Settings.add_business');
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  const handlePrompt = (status = true) => setPrompt(status);

  return (
    <>
      <Prompt
        when={showPrompt}
        message={t("common.leave_page_warning")}
      />
      <FormLayout
        title={t('Settings.add_new_business')}
        Icon={OrganizationIcon}
        closeUrl="/oc/organization/choose"
        layoutBoxClass="uiux-form-redesign"
      >
        <OrganizationForm
          type="Add"
          handleToast={handleToast}
          handleCrossAlert={handleCrossAlert}
          setPrompt={handlePrompt}
        />
      </FormLayout>
    </>
  );
};

export default AddOrganization;
